module.exports = __webpack_public_path__ + "img/ewm-dingyuehao.05600079.png";